import React, { useCallback, useState, useContext } from 'react';
import useTranslations from '../../hooks/useTranslations';
import { FetchCallbacksContext } from '../../internal-components/FetchCallbacks';
import FormBuilderStatusItemView from '../view/FormBuilderStatusItemView';
import { Context } from './FormBuilderStatusesEngine';

const FormBuilderStatusItemEngine = ({
  statusName = '',
  isLocked4EndUsers,
  nameMaxLength = 32,
  position = 0,
  id,
  updateName = n => n,
  updateLocked4EndUsers = l => l,
  onDelete = () => {}
}) => {
  const { data: statuses, getStatusUsage } = useContext(Context);
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const t = useTranslations();
  const [name, setName] = useState(statusName);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isInDeleteSequence, setIsInDeleteSequence] = useState(false);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [isInputHovered, setIsInputHovered] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const onNameInputBlur = useCallback(() => {
    const newName = name.trim();
    const oldName = statuses[position].statusName;
    const isNameEmpty = newName.length === 0;
    let isNameExist = false;

    const statusesWithSameName = statuses.filter(
      s => s.statusName.trim() === newName
    );
    if (
      statusesWithSameName &&
      (statusesWithSameName.length > 1 ||
        (statusesWithSameName[0] && statusesWithSameName[0].id !== id))
    ) {
      isNameExist = true;
    } else if (
      statusesWithSameName &&
      statusesWithSameName[0] &&
      statusesWithSameName[0].id === id
    ) {
      // Name didn't change - no need for update
      return;
    }

    if (isNameEmpty) {
      setTimeout(() => {
        openSnackbar('error', t('statuses.error.nameEmpty'));
      }, 100);
      setName(oldName);
      return;
    }
    if (isNameExist) {
      setTimeout(() => {
        openSnackbar('error', t('statuses.error.nameExist'));
      }, 100);
      setName(oldName);
      return;
    }

    updateName(newName);
  }, [name, statuses]);

  const onToggleLock4EndUsers = useCallback(() => {
    const newLockStatus = !isLocked4EndUsers;
    if (newLockStatus) {
      openSnackbar('success', t('statuses.snackbar.locked'));
    } else {
      openSnackbar('success', t('statuses.snackbar.unlocked'));
    }
    updateLocked4EndUsers(newLockStatus);
  }, [isLocked4EndUsers, statuses]);

  const onDeleteClicked = useCallback(async () => {
    const usage = await getStatusUsage(id);
    if (!!usage.length) {
      openSnackbar(
        'error',
        <>
          {t('statuses.status.uses.err')}
          <ul>
            {usage.map(loc => (
              <li key={loc}>{t(`statuses.status.uses.err.${loc}`)}</li>
            ))}
          </ul>
        </>,
        true
      );
    } else {
      setIsDeleteDialogOpen(true);
    }
  }, [getStatusUsage]);

  const viewProps = {
    nameMaxLength,
    name,
    isLocked4EndUsers,
    setName,
    maxedNameSize: nameMaxLength - name.length === 0,
    onNameInputBlur,
    onToggleLock4EndUsers,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    isInDeleteSequence,
    setIsInDeleteSequence,
    onDelete,
    position,
    id,
    isCardHovered,
    setIsCardHovered,
    isInputHovered,
    setIsInputHovered,
    isInputFocused,
    setIsInputFocused,
    onDeleteClicked
  };

  return <FormBuilderStatusItemView {...viewProps} />;
};

export default FormBuilderStatusItemEngine;
